export const SET = 'SET';
export const FETCH = 'FETCH';

export const GET_PARAMETERS = 'GET_PARAMETERS';
export const SET_PARAMETERS = 'SET_PARAMETERS';

